export default "__VITE_ASSET__LbjyR$sM__"